import React from 'react';
import { useTranslation } from 'react-i18next';
import Button, { ButtonType } from 'legacy/common/components/button/Button';

interface DownloadCSVButtonProps {
  onClick: () => void;
  loading?: boolean;
  text?: string;
}

const DownloadCSVButton: React.FC<DownloadCSVButtonProps> = ({
  onClick,
  loading,
  text
}) => {
  const { t } = useTranslation(['events']);

  return (
    <Button
      type={ButtonType.Text}
      icon={<img src="/img/events/csv.svg" alt="CSV icon" />}
      onClick={onClick}
      loading={loading}
      className="text-[#3853C4]"
    >
      {text || t('events:dashboard.ticketing.downloadCSV')}
    </Button>
  );
};

export default DownloadCSVButton;
